<script>
import toggleModal from '@/mixins/toggleModal';
import UploadImages from '@/components/ux/upload/Upload-images.vue';
import { mapActions } from 'vuex';

export default {
  components: { UploadImages },
  data() {
    return {
      desktopFileList: [],
      mobileFileList: [],
      isMultiple: false,
    };
  },
  props: {
    categoryObject: {
      type: Object,
    },
    isNewCategory: {
      type: Boolean,
      required: true,
    },
  },
  mixins: [toggleModal],
  methods: {
    ...mapActions({
      addOrEditCategory: 'blogs/addOrEditCategory',
    }),
    onCancel() {
      this.hideModal();
      this.$emit('update:clearCategory', null);
    },
    onSave(values) {
      this.addOrEditCategory({
        id: this.isNewCategory ? null : this.categoryObject.id,
        isNew: this.isNewCategory,
        desktopImage: this.desktopFileList,
        mobileImage: this.mobileFileList,
        values,
        callback: this.onCancel,
      });
    },
  },
};
</script>

<template>
  <a-modal :open="show" :footer="null" @cancel="onCancel" >
    <h1>
      {{ isNewCategory ? 'Create new' : 'Edit' }} category
    </h1>
    <FormKit
      type="form"
      submit-label="Save"
      @submit="onSave"
    >
      <FormKit
        type="text"
        name="name"
        :value="(categoryObject || {}).name || ''"
        label="Title"
        placeholder="Enter title"
        validation="required"
      />
      <FormKit
        type="text"
        name="seoTitle"
        :value="(categoryObject || {}).seoTitle || ''"
        label="Title SEO"
        placeholder="Enter title SEO"
        validation="required"
      />
      <FormKit
        type="text"
        name="navTitle"
        :value="(categoryObject || {}).navTitle || ''"
        label="Button Navigation Title"
        placeholder="Enter button navigation title"
        validation="required"
      />
      <FormKit
        type="text"
        name="url"
        :value="(categoryObject || {}).url || ''"
        label="Url"
        placeholder="Enter url"
        validation="required"
      />
      <FormKit
        type="text"
        name="description"
        :value="(categoryObject || {}).description || ''"
        label="Description"
        placeholder="Enter description"
        validation="required"
      />
      <FormKit
        type="text"
        name="seoDescription"
        :value="(categoryObject || {}).seoDescription || ''"
        label="Description SEO"
        placeholder="Enter description SEO"
        validation="required"
      />
      <FormKit
        type="text"
        name="summeryDescription"
        :value="(categoryObject || {}).summeryDescription || ''"
        label="Summary description"
        placeholder="Enter summary description"
        validation="required"
      />
      <FormKit
        type="select"
        name="type"
        label="Category type"
        placeholder="Please select category type"
        :value="(categoryObject || {}).type || ''"
        :options="[
          { value: 'digitize', label: 'Digitize' },
          { value: 'enhance', label: 'Enhance' },
        ]"
        validation="required"
      />
      <div class="row">
        <div class="image-uploader-wrapper">
          <h4>Desktop image</h4>
          <UploadImages
            v-model:files="this.desktopFileList"
            :isMultiple="this.isMultiple"
            :initialImages="
              categoryObject && categoryObject.imageUrl
                ? [categoryObject.imageUrl]
                : []
            "
          />
        </div>
        <div class="image-uploader-wrapper">
          <h4>Mobile image</h4>
          <UploadImages
            v-model:files="this.mobileFileList"
            :isMultiple="this.isMultiple"
            :initialImages="
              categoryObject && categoryObject.mobileImageUrl
                ? [categoryObject.mobileImageUrl]
                : []
            "
          />
        </div>
      </div>
    </FormKit>
  </a-modal>
</template>

<style lang="scss" scoped>
  .formkit-wrapper {
    display: flex;
    justify-content: flex-end;
  }
  .row {
    display: flex;
    gap: 40px;
  }
  .image-uploader-wrapper {
    width: min-content;
    height: min-content;
  }

</style>
